var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0303 0.46967C11.3232 0.762563 11.3232 1.23744 11.0303 1.53033L2.56066 10L11.0303 18.4697C11.3232 18.7626 11.3232 19.2374 11.0303 19.5303C10.7374 19.8232 10.2626 19.8232 9.96967 19.5303L0.96967 10.5303C0.676777 10.2374 0.676777 9.76256 0.96967 9.46967L9.96967 0.46967C10.2626 0.176777 10.7374 0.176777 11.0303 0.46967Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.b4d6d7a732a8ef08adda535d8427d1a5.svg";
export { ForwardRef as ReactComponent };